// Archive of completed installations. Each entry leads with the FINISH —
// the material and treatment are the point, not the residence. Locations
// stay on the sub-line as a light editorial signal.
export const PROJECTS = [
  {
    id: "kirribilli-oak",
    title: "Wide-Plank Oak",
    location: "Harbour Residence · Kirribilli",
    year: 2025,
    discipline: "Timber",
    material: "Oak · 300mm plank · natural matte",
    image: "/archive/kirribilli-oak.jpg",
    caption: "Long, continuous 300mm oak planks run corner to corner, catching a low afternoon light on a subtle brushed grain.",
  },
  {
    id: "paddington-wool-loop",
    title: "Wool Loop-Pile · Custom Weave",
    location: "Terrace · Paddington",
    year: 2024,
    discipline: "Carpet",
    material: "Handspun wool · chunky loop pile · warm cream",
    image: "/archive/paddington-wool-loop.jpg",
    caption: "A dense, hand-loomed wool loop laid wall-to-wall — every pile stitch reads under raking morning light.",
  },
  {
    id: "double-bay-travertine",
    title: "Book-Matched Travertine",
    location: "Ground-floor pavilion · Double Bay",
    year: 2025,
    discipline: "Stone",
    material: "Cream Travertine · 1200×1200 · polished satin",
    image: "/archive/double-bay-travertine.jpg",
    caption: "Book-matched 1200×1200 travertine — the vein mirrored across each seam so the pattern reads as one continuous plane.",
  },
  {
    id: "mosman-porcelain",
    title: "Large-Format Porcelain",
    location: "Open-plan kitchen · Mosman",
    year: 2024,
    discipline: "Tile",
    material: "Porcelain slab · 1200×2400 · matte off-white",
    image: "/archive/mosman-porcelain.jpg",
    caption: "1200×2400 porcelain slabs seam-matched across the whole living plane, with fine grey veining and a soft matte finish.",
  },
  {
    id: "vaucluse-walnut-herringbone",
    title: "Smoked Walnut Herringbone",
    location: "Double-height gallery · Vaucluse",
    year: 2023,
    discipline: "Timber",
    material: "American Walnut · smoked · herringbone parquet",
    image: "/archive/vaucluse-walnut-herringbone.jpg",
    caption: "Smoked walnut herringbone in a deep espresso tone — the parquet geometry laid perfectly on-axis with the gallery's window bays.",
  },
  {
    id: "bellevue-limestone",
    title: "Honed Cream Limestone",
    location: "Entry hall · Bellevue Hill",
    year: 2025,
    discipline: "Stone",
    material: "Limestone · 800×800 · tumbled edge · honed",
    image: "/archive/bellevue-limestone.jpg",
    caption: "Sun-bleached limestone honed to a chalk-soft matte — tumbled edges soften the grid so the floor feels ancient and modern at once.",
  },
  {
    id: "surry-hills-wool-sisal",
    title: "Hybrid Wool-Sisal",
    location: "Loft bedroom · Surry Hills",
    year: 2024,
    discipline: "Carpet",
    material: "Undyed wool + sisal · natural weave",
    image: "/archive/surry-hills-wool-sisal.jpg",
    caption: "A tactile hybrid of soft wool and coarse sisal — quietly textural, sound-absorbing, and completely natural in tone.",
  },
  {
    id: "manly-terrazzo",
    title: "Custom Terrazzo",
    location: "Poolside pavilion · Manly",
    year: 2025,
    discipline: "Tile",
    material: "Custom aggregate terrazzo · polished",
    image: "/archive/manly-terrazzo.jpg",
    caption: "Bespoke terrazzo poured to the exact curve of the pool edge — caramel, charcoal and cream chips set in a warm base.",
  },
];

export const DISCIPLINES = ["All", "Timber", "Carpet", "Tile", "Stone"];
